import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '商品分類', href: '#collections', type: 'scroll' },
  { label: '限時折扣', href: '#hot-deals', type: 'scroll' },
  { label: '穿搭指南', href: '/style-guide', type: 'route' },
  { label: '關於我們', href: '/about', type: 'route' },
  { label: '實體店面', href: '#location', type: 'scroll' },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string, type: string) => {
    setMenuOpen(false);
    if (type === 'route') {
      navigate(href);
    } else {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const el = document.querySelector(href);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      } else {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-cream-200'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-[72px]">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/b54fcf7f-2746-4923-b8b9-39fce8de023d.png"
            alt="品牌 Logo"
            className="h-10 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.label}>
              <button
                onClick={() => handleNavClick(link.href, link.type)}
                className={`text-[1.0625rem] font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? 'text-warm-900 hover:text-gold-500'
                    : 'text-white hover:text-gold-200'
                } ${location.pathname === link.href ? 'text-gold-500' : ''}`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleNavClick('#hot-deals', 'scroll')}
            className={`text-[1.0625rem] font-medium px-5 py-2 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
              scrolled
                ? 'border-warm-900 text-warm-900 hover:bg-warm-900 hover:text-white'
                : 'border-white text-white hover:bg-white hover:text-warm-900'
            }`}
          >
            立即探索
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer ${
            scrolled ? 'text-warm-900' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="開啟選單"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-cream-200 px-6 py-4">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.label}>
                <button
                  onClick={() => handleNavClick(link.href, link.type)}
                  className="text-[1.125rem] font-medium text-warm-900 hover:text-gold-500 transition-colors cursor-pointer w-full text-left py-1"
                >
                  {link.label}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => handleNavClick('#hot-deals', 'scroll')}
                className="mt-2 w-full text-center text-[1.0625rem] font-medium px-5 py-2.5 rounded-full bg-warm-900 text-white cursor-pointer whitespace-nowrap"
              >
                立即探索
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
